angular.module('app')
  .factory('LotSuggest', LotSuggest);

/*@ngInject*/
function LotSuggest($http, $q, SuggestApiConfiguration) {
  return { search };

  function search(typeLot, query) {

    return $http({
      method: 'GET',
      cache: true,
      url: SuggestApiConfiguration.lotUri,
      params: { query: query, typeLot: typeLot }
    });
  }
}
